package dev.danko.roblox_craft_ai.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController
import dev.danko.roblox_craft_ai.uikit.i18n.strings
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.cssRem

enum class LegalDoc(val slug: String) { TERMS("terms"), PRIVACY("privacy"), REFUNDS("refunds") }

/** Legal documents exist in Russian and English: Russian for ru/uk readers, English (the binding text) for the rest. */
fun legalPath(doc: LegalDoc, localeCode: String = LocaleController.current.code): String =
    "/legal/${if (localeCode == "ru" || localeCode == "uk") "ru" else "en"}/${doc.slug}"

/** Small inline links to the given documents, separated by dots. Safe to use outside pages (no page context). */
@Composable
fun LegalLinks(docs: List<LegalDoc> = LegalDoc.entries, modifier: Modifier = Modifier) {
    val s = strings().legal
    val palette = LocalAppTheme.current.colors
    Row(modifier.gap(0.4.cssRem).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
        docs.forEachIndexed { i, doc ->
            if (i > 0) SpanText("·", Modifier.color(palette.textSecondary))
            // A plain anchor, not Kobweb's Link: these links also render in the sign-in dialog, which is mounted
            // outside any page and has no page context for client-side routing.
            A(
                legalPath(doc),
                Modifier.color(palette.textSecondary)
                    .styleModifier { property("text-decoration", "underline"); property("text-underline-offset", "3px") }
                    .toAttrs()
            ) {
                Text(
                    when (doc) {
                        LegalDoc.TERMS -> s.terms
                        LegalDoc.PRIVACY -> s.privacy
                        LegalDoc.REFUNDS -> s.refunds
                    }
                )
            }
        }
    }
}

@Composable
fun SiteFooter() {
    val palette = LocalAppTheme.current.colors
    Box(
        Modifier.fillMaxWidth().margin(top = 3.cssRem).padding(topBottom = 1.5.cssRem, leftRight = 1.cssRem)
            .styleModifier { property("border-top", "1px solid ${palette.border}") },
        contentAlignment = Alignment.Center
    ) {
        Column(Modifier.fillMaxWidth().maxWidth(72.cssRem).gap(0.5.cssRem).fontSize(0.85.cssRem)) {
            Row(Modifier.fillMaxWidth().gap(1.cssRem).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                SpanText("© 2026 Craftiva AI", Modifier.color(palette.textSecondary))
                LegalLinks()
            }
            SpanText(strings().legal.notAffiliated, Modifier.fontSize(0.78.cssRem).color(palette.textSecondary).opacity(0.8))
        }
    }
}
